import { FC, useEffect } from "react";
import "shepherd.js/dist/css/shepherd.css";
import { useOnboardingTour } from "../hooks/useOnboardingTour";
import "../styles/shepherd-custom.css";

interface CasePageTourProps {
  isReady: boolean;
}

export const CasePageTour: FC<CasePageTourProps> = ({ isReady }) => {
  const { startTour, shouldShowTour } = useOnboardingTour({
    tourType: "casePage",
    enabled: isReady,
  });

  useEffect(() => {
    if (isReady && shouldShowTour()) {
      const timer = setTimeout(() => {
        startTour();
      }, 500);
      return () => clearTimeout(timer);
    }
  }, [isReady, shouldShowTour, startTour]);

  return null;
};
